/** Figma API — Faz 1.4 createApi factory. */
import {createApi} from './_factory'
import type {IntegrationNs, ScreenNs} from '@shared/types'

const api = createApi('figma')

export const FigmaApi = {
  getRootNodes: (data: IntegrationNs.BaseFigmaRequest) =>
    api.post<IntegrationNs.BaseFigmaRequest, IntegrationNs.FigmaNode[]>('get-root-nodes', data),
  getChildNodes: (data: IntegrationNs.GetChildNodesRequest) =>
    api.post<IntegrationNs.GetChildNodesRequest, IntegrationNs.FigmaNode[]>('get-child-nodes', data),
  saveImageAsScreen: (data: IntegrationNs.FigmaImageUploadRequest) =>
    api.post<IntegrationNs.FigmaImageUploadRequest, ScreenNs.Screen[]>('save-images-as-screen', data),
  updateScreenFromFigma: (data: ScreenNs.UpdateScreenFromFigmaRequest) =>
    api.post<ScreenNs.UpdateScreenFromFigmaRequest, ScreenNs.Screen>('update-screen-from-figma', data),
  getFigmaProjectName: (data: ScreenNs.GetFigmaProjectNameRequest) =>
    api.post<ScreenNs.GetFigmaProjectNameRequest, ScreenNs.FigmaProjectNameResponse>('get-figma-project-name', data),
}
